// gatsby-browser.js
import React from 'react';
import { GlobalProvider } from './src/services/GlobalContext'
import './src/styles/global.css';
import './src/styles/cookies.css';

export const wrapRootElement = ({ element }) => {
  return <GlobalProvider>{element}</GlobalProvider>;
};
